module.exports = __webpack_public_path__ + "img/ascend_gold16.fae0004b.png";